require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var Handlebars = require('handlebars');

var Template = require('text-loader!../../templates/queue_monitor_templates/queue_monitor_two.template.htm');
var Pagination = require('../../views/pagination.view.ts');
var i18n = require('l10n');

require('../../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js');

var TheView = Backbone.View.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function (options) {

	},
	superRender: Backbone.View.prototype.render,
    render: function() {

        this.$el.html(this.template( {queueCollection: this.queues} ));
    },
	events:{

	},
	data: function(collection) {
	    if( collection == null) {
	        this.queues = collection;
	        this.render();
	        return ;
	    }

        this.queues = collection;
        this.render();
	},
	updateQueue: function(queue) {
        this.queues = this.queues.map(obj => {
            if(obj.queue.id == queue.queue.id) return queue;

            return obj;
        });

	    this.render();
	},
	updateLessInfo: function(info) {

	},
	destroy: function() {

    }
});

module.exports = TheView;